(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-id/assets/javascripts/use-current-coupon-rows.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-id/assets/javascripts/use-current-coupon-rows.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useMemo = _React.useMemo;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const useCouponId = svs.components.tipsen.couponId.useCouponId;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const _svs$components$sport = svs.components.sport.tipsenShared,
  signIndexToOutcome = _svs$components$sport.signIndexToOutcome,
  signIndexToTitle = _svs$components$sport.signIndexToTitle;
const _svs$components$tipse = svs.components.tipsen.engine.selectors.couponSelectors,
  selectSigns = _svs$components$tipse.selectSigns,
  selectMSigns = _svs$components$tipse.selectMSigns,
  selectUSigns = _svs$components$tipse.selectUSigns,
  selectSystemType = _svs$components$tipse.selectSystemType,
  selectSignDistribution = _svs$components$tipse.selectSignDistribution;
const _svs$components$tipse2 = svs.components.tipsen.engine.constants.systems,
  SYSTEM_USYS = _svs$components$tipse2.SYSTEM_USYS,
  SYSTEM_RSYS = _svs$components$tipse2.SYSTEM_RSYS;
const selectOutcomesEventTypeId = svs.components.tipsen.engine.selectors.engineSelectors.selectOutcomesEventTypeId;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const DescriptionSize = svs.components.lbUi.participants.constants.DescriptionSize;
const _svs$components$sport2 = svs.components.sportinfo.matchInfoRedux.selectors,
  selectAllParticipants = _svs$components$sport2.selectAllParticipants,
  selectBetEvents = _svs$components$sport2.selectBetEvents;
const createBetEventKey = svs.components.sportinfo.common.helpers.createBetEventKey;
const useCurrentCouponRows = function () {
  let boardIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  const draw = useCurrentDraw();
  const couponId = useCouponId();
  const systemType = useSelector(state => selectSystemType(state, couponId));
  const signs = useSelector(state => selectSigns(state, couponId, boardIndex));
  const mSigns = useSelector(state => selectMSigns(state, couponId, boardIndex));
  const uSigns = useSelector(state => selectUSigns(state, couponId, boardIndex));
  const signDistribution = useSelector(state => selectSignDistribution(state, couponId, boardIndex));
  const eventTypeId = useSelector(selectOutcomesEventTypeId);
  const index2Sign = signIndexToOutcome[eventTypeId];
  const signTitle = signIndexToTitle[eventTypeId];
  const betEvents = useSelector(selectBetEvents);
  const participants = useSelector(selectAllParticipants);
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const drawEventNumbers = useMemo(() => draw.drawEvents.map(_ref => {
    let eventNumber = _ref.eventNumber;
    return eventNumber;
  }), [draw.drawEvents]);
  const participantsInDraw = useMemo(() => drawEventNumbers.map(eventNumber => {
    var _betEvents$betEventKe, _betEvents$betEventKe2;
    const betEventKey = createBetEventKey(draw.productId, draw.drawNumber, eventNumber);
    const _ref2 = (_betEvents$betEventKe = (_betEvents$betEventKe2 = betEvents[betEventKey]) === null || _betEvents$betEventKe2 === void 0 ? void 0 : _betEvents$betEventKe2.participants) !== null && _betEvents$betEventKe !== void 0 ? _betEvents$betEventKe : [],
      _ref3 = _slicedToArray(_ref2, 2),
      home = _ref3[0],
      away = _ref3[1];
    return {
      home: participants[home],
      away: participants[away]
    };
  }), [draw.productId, draw.drawNumber, participants, betEvents, drawEventNumbers]);
  const couponRows = useMemo(() => drawEventNumbers.map(eventNumber => {
    var _participantsInDraw, _signs, _signs2;
    const _ref4 = (_participantsInDraw = participantsInDraw[eventNumber - 1]) !== null && _participantsInDraw !== void 0 ? _participantsInDraw : {},
      home = _ref4.home,
      away = _ref4.away;
    const numSelected = signs === null || signs === void 0 || (_signs = signs[eventNumber - 1]) === null || _signs === void 0 ? void 0 : _signs.filter(selected => selected === true).length;
    const moreThanFourSelected = numSelected > 4;
    const moreThanSixSelected = numSelected > 6;
    let nameSize = DescriptionSize.Full;
    if (isSmall && moreThanFourSelected) {
      nameSize = DescriptionSize.Short;
    } else if (isSmall || moreThanSixSelected) {
      nameSize = DescriptionSize.Medium;
    }
    return {
      signDistribution: signDistribution[eventNumber - 1],
      eventNumber,
      homeParticipant: home,
      awayParticipant: away,
      nameSize,
      systemType,
      mSign: (mSigns === null || mSigns === void 0 ? void 0 : mSigns[eventNumber - 1]) && (systemType === SYSTEM_RSYS || systemType === SYSTEM_USYS),
      options: signs === null || signs === void 0 || (_signs2 = signs[eventNumber - 1]) === null || _signs2 === void 0 ? void 0 : _signs2.map((isSelected, signIndex) => ({
        isSelected,
        sign: signTitle[signIndex],
        hasUSign: index2Sign[signIndex] === index2Sign[uSigns[eventNumber - 1]] && systemType === SYSTEM_USYS
      }))
    };
  }), [drawEventNumbers, participantsInDraw, isSmall, mSigns, signDistribution, signs, systemType, uSigns, index2Sign, signTitle]);
  return couponRows;
};
setGlobal('svs.components.tipsen.couponId.useCurrentCouponRows', useCurrentCouponRows);

 })(window);